import React, { useEffect } from 'react';
import { Card, Row, Col, Modal, Form, InputGroup, DropdownButton, Dropdown } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { updateProfile } from '../../../../middleware/dynamicProfileRender';
import DeleteModal from '../DeleteModal/delete';
import W4EditModal from './w4';
import { useQuery } from '@tanstack/react-query';
import { getEmployee } from '../../../../../../api/services/default/employee';
import { Skeleton } from '@material-ui/lab';



const W4 = (props) => {
    const [modalShow, setModalShow] = React.useState(false);
    const [modalShowDel, delModalShow] = React.useState(false);
    const {employeeID,isPersonal} = props
    const [index, setIndex] = React.useState(undefined)
    const { data : employeeData = {} } = useQuery({
        queryKey: ["getEmployee", employeeID],
        queryFn: () => getEmployee(employeeID),
        enabled: !!employeeID,
      })
    useEffect(() => {}, [employeeData]);
    const handleEdit = (idx) => {
        setModalShow(true)
        setIndex(idx)
    }

    const handleAdd = () => {
        setModalShow(true)
        setIndex(undefined)
    }

    const dispatch = useDispatch()

    const handleDelete = (idx) => {
        delModalShow(true);
        setIndex(idx)
      };
  
    const handleDeleteData = (index) => {
        if (index > -1) { 
            employeeData?.w4?.splice(index, 1); 
          }
        delModalShow(false)
        let w4 = employeeData?.w4?.map((item) => item)
        const payload = {
            w4
        }
        setModalShow(false)
        dispatch(updateProfile(payload,employeeID,payload))
    }
    return (
        <>
        {Object.values(employeeData).length ? (
        <>
            <W4EditModal
                show={modalShow}
                employeeID={employeeID}
                data={employeeData?.w4}
                idx={index}
                onHide={() => setModalShow(false)}
            />
             <DeleteModal
                 show={modalShowDel}
                 index={index}
                 handleDelete={() => handleDeleteData(index)}
                 onHide={() => delModalShow(false)}
            />
            <Card>
                <Card.Body>
                    <div className="d-flex justify-content-between">
                        <h5 className="card-title mb-3 header-title">W4</h5>
                        {
                            isPersonal ?
                            <>
                            </> :
                            <Link to="#"className="linkbtn me-1 mt-0" onClick={() => handleAdd()}><i className="fa-solid fa-square-plus fs-17"></i></Link>
                        }
                    </div>
                    {
                        employeeData?.w4?.map((res, idx) => {
                            return (
                                <div className="emplbg mb-2">
                        <div className="d-block d-lg-flex justify-content-between my-1">
                            <div>       
                                    <div className="ms-2">
                                        {
                                            res?.w4status === 'Active' ? 
                                            <h5 className="mb-1 mt-0 align-self-center fw-bold fs-15"><span className="text-success fw-medium mt-0 mb-1">{res?.w4status}</span></h5>
                                            : 
                                            <h5 className="mb-1 mt-0 align-self-center fw-bold fs-15"><span className="text-danger fw-medium mt-0 mb-1">{res?.w4status}</span></h5>
                                        }
                                        <h6 className="text-muted fw-normal mt-0 mb-1">verified by:  {res?.verifiedby}</h6>
                                        <h6 className="text-muted fw-normal mt-0 mb-1">Uploaded on {res?.uploadedon}</h6>
                                    </div>
                            </div>
                            <div className="d-flex mt-2 mt-lg-0">
                                <a href={res?.w4document} target="_blank" class="wauth me-1 badge-soft-danger badge rounded-pill fw-medium" rel="noreferrer"><i className="fa-regular fa-folder-open pe-1"></i>View Document</a>
                                {
                                    isPersonal ?
                                    <></>
                                    :
                                    <>
                                     <Link to="#" className="linkbtn me-1 mt-0" onClick={() => handleEdit(idx)}><i className="fa-solid fa-pen fs-17"></i></Link>
                                     <Link to="#" className="linkbtn danger mt-0" onClick={() => handleDelete(idx)}><i className="fa-regular fa-trash-can fs-17"></i></Link>
                                    </>
                                }
                              </div>
                        </div>
                    </div>
                            )
                        })
                    }
                    
                </Card.Body>
            </Card>
        </>
         ) : (
            <Skeleton variant="rounded" height={260} />
        )}
        </>
    );
};
export default W4;